import React, { useState, useEffect } from 'react';
import { FaLightbulb } from 'react-icons/fa';
import { ExpandHeader, ToolCallWrapper, ExpandedContent } from '../ToolCall/shared/ToolCallComponents';

interface ThinkingProps {
    item: {
        type: 'thinking' | 'redacted_thinking';
        thinking?: string;
        data?: string;
        signature?: string;
    };
}

const Thinking: React.FC<ThinkingProps> = ({ item }) => {
    const [isExpanded, setIsExpanded] = useState(item.signature === undefined);
    const isRedacted = item.type === 'redacted_thinking';

    useEffect(() => {
        if (item.signature !== undefined) {
            setIsExpanded(false);
        }
    }, [item.signature]);

    return (
        <ToolCallWrapper>
            <ExpandHeader
                icon={<FaLightbulb className="mr-2 text-neutral-500 dark:text-neutral-400" size={14}/>}
                title="Thinking"
                isExpanded={isExpanded}
                isInProgress={false}
                onClick={() => setIsExpanded(prev => !prev)}
            />
            {isExpanded && (
                <ExpandedContent>
                    <div className="text-sm text-neutral-600 dark:text-neutral-400 italic">
                        {isRedacted
                            ? "Thoughts hidden"
                            : item.thinking || ""}
                    </div>
                </ExpandedContent>
            )}
        </ToolCallWrapper>
    );
};

export default Thinking;